import { mapGetters } from 'vuex'
import {EventBus} from "@/utils/event-bus";

const base={
  data(){
     
    let assetView=[182,2,115,282];
    let assetInsert=[5,117,3,116,244,293];
    let assetReport=[23];
    let operateOverview=[318]; // 运营概况；
    let operateOrder=[75,76,229,230,311]; //订单管理；
    let operateBusiness=[11,10,196,262,14,242]; //业务管理；
    let operatePrice=[12]; //定价管理；
    let operateCustomer=[73,306,236,74,249,]; //客户管理；
    let operateFinance=[19,276,101,255]; //财务管理；
    let operateReport=[69]; //运营报表；
    let marketingActivities=[336]; //营销活动
    let remoteUpgrade=[342];

    let onlineMonitoring=[16,172,224,17];  //线上监控
    let offlineAftersale=[205,207,299,321]; //线下售后
    let personManager=[206,208]; //人员管理
    let aftersaleReport=[24]; //售后报表

    let accountManager=[26];
    let roleManager=[27];
    let DataDictionary=[28];
    let permissionGroup={
          assetManager:{
            assetView,assetInsert,assetReport
          },
          operateManager:{
             operateOverview,operateOrder,operateBusiness,operatePrice,operateCustomer,operateFinance,operateReport,marketingActivities,remoteUpgrade
          },
          aftersaleManager:{
            onlineMonitoring,offlineAftersale,personManager,aftersaleReport
          },
          systemSettings:{
            accountManager,roleManager,DataDictionary
          }
    }
    return {screenWidth: 0,permissionGroup}
  },
  computed: {
    ...mapGetters([
      'theme',
    ]),
    calcFontSize() {
      return function (value, min) {
        let size = (value / 1920 * this.screenWidth);
        if (min) {
          if (size < min) {
            size = min;
          }
        }
        return size + 'px';
      }

    },
  },
  mounted() {
    this.handleReSize = (e) => {
      this.screenWidth = document.body.clientWidth;
    }
    window.addEventListener('resize', this.handleReSize);
    this.handleReSize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleReSize)
  },
  beforeRouteEnter(to, form, next) {
    EventBus.$emit("startPage",to);
    next()

  },
  beforeRouteLeave(to, form, next) {
    // let formList= localStorage.getItem("form");
    // if(!formList){
    //   formList=[]
    // }else{
    //   formList=JSON.parse(formList)
    // }
    // formList.push({name:form.name});
    // localStorage.setItem("form",JSON.stringify(formList));
    EventBus.$emit("endPage",form);
    next()

  },
  methods:{
    hasPermission(id) {
      return this.$store.getters.hasPermission(id);
    },
    hasPermissionGroup(ids) {
      for(var i=0;i<ids.length;i++){
        if( this.$store.getters.hasPermission(ids[i])){
          return true;
        }
      } 
      return false;

      ;
    },
    getPageInfo({label,name,last}){
      return {page:this.$route.name,label:label,last,route:this.$route,that:this}
    },
    //列控制
    isShowColumn(table,field) {
      return this.$store.getters.isShowColumn(table,field);
    },
    loadImage(path){
      if(this.theme=="theme1"){
              return require("@/assets/theme1"+path);
      }
      if(this.theme=="theme2"){
        return require("@/assets/theme2"+path);
      }
      if(this.theme=="theme2_skyblue"){
        return require("@/assets/theme2"+path);
      }
    },
    closeCurrentPageAndJumpToPage(params){
      this.$store.dispatch("tagsView/delView", Object.assign({}, this.$route))
        .then(({ visitedViews }) => {
          if(params){
            this.$router.push(params);
          }

        });
    },
    toCachePage(params){
      if(!params){
        return;
      }
      let find=false;
      let visitedViews= this.$store.state.tagsView.visitedViews;
      if(visitedViews){
        for (let i = 0; i < visitedViews.length; i++) {
          let view=visitedViews[i];


               if( view.name==params.name || view.path==params.path){
                  find=true;
                  this.$store
                    .dispatch("tagsView/delView",  Object.assign({}, view))
                    .then(({ visitedViews }) => {

                      this.$router.push(params);
                    });

                }

        }
      }
      if(!find){
        this.$router.push(params);
      }

      console.log(visitedViews);
    },

    isShowCol(field) {
      let sd= this.colData.filter((item)=>{return item.field===field})
      return sd[0].istrue
      
    },

  }
}
export default base;



// WEBPACK FOOTER //
// ./src/components/Mixin/base.js